import { Module } from 'vuex'
import actions from './actions'
import mutations from './mutations';
import RootState from '@vue-storefront/core/types/RootState';
import VacanciesState from '../types/VacanciesState';
import config from 'config'

export const module: Module<VacanciesState, RootState> = {
  namespaced: true,
  state: {
    vacancies: []
  },
  actions,
  mutations
}
